// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1oqAS","signatureButtonsRight":"ModalSign_signatureButtonsRight__LdEY_"};